// src/utils/testTelegramData.js
import CryptoJS from 'crypto-js';


export const generateTestInitData = (userData = {}) => {
  const botToken = process.env.REACT_APP_BOT_TOKEN;

  const data = {
    auth_date: Math.floor(Date.now() / 1000),
    user: JSON.stringify({
      id: 485623986,
      first_name: 'Pavel',
      last_name: 'User',
      username: 'testuser',
      language_code: 'ru',
      is_premium: true,
      ...userData
    }),   
  };

  // Сортировка по ключам
  const sortedKeys = Object.keys(data).sort();
  let dataCheckString = sortedKeys.map(key => `${key}=${data[key]}`).join('\n');

  // Правильная реализация по документации Telegram
  const secretKey = CryptoJS.HmacSHA256(botToken, 'WebAppData');
  const hash = CryptoJS.HmacSHA256(dataCheckString, secretKey).toString(CryptoJS.enc.Hex);

  data.hash = hash;

  return new URLSearchParams(data).toString();
};